import React from 'react';
import defaultContext from './defaultContext';

const AppContext = React.createContext({
  locale: defaultContext.defaultLng,
  currentPage: '',
  setLocale: () => {},
  setCurrentPage: () => {},
});

export default AppContext;
